import { useLazySessionSearch as useSharedLazySessionSearch } from '@fs/zion-rootstech'
import useErrorHandlerOverlay from '../useErrorHandlerOverlay'

export default function useLazySessionSearch(includeAudiences) {
  const [search, result] = useSharedLazySessionSearch(includeAudiences)
  useErrorHandlerOverlay(result.error)
  return [search, result]
}
